import React, {Component} from 'react';
import { getTranslator } from '~/translations';
import PropTypes from 'prop-types';
import { connect as reduxConnect, batch } from 'react-redux';
import {getFallbackLanguage, getLanguage} from "~/stateGetter";
import { reportError } from "~/lib/reportErrors";

import debounce from "lodash/debounce";
const debouncedReportError = debounce(reportError, 100, { leading: true })

function connectInner(mapStateToProps = null, mapDispatchToProps = null, mergeProps = null, ...args) {
    return reduxConnect((state, ownProps) => {
        let originalStateProps = {},
            language = getLanguage(state),
            fallbackLanguage = getFallbackLanguage(state);

        if(mapStateToProps) {
            originalStateProps = mapStateToProps(state, ownProps);
        }

        return {
            language,
            fallbackLanguage,
            ...originalStateProps,
        }
    }, mapDispatchToProps, (props, dispatchers, ownProps, ...mergePropsArgs) => {
        let originalMergeProps = {},

        trans = getTranslator(props.language,props.fallbackLanguage);

        if(mergeProps) {
            try {

                originalMergeProps = mergeProps(props, dispatchers, {trans, ...ownProps}, ...mergePropsArgs);
                return {
                    trans,
                    ...originalMergeProps,
                }
            } catch (e) {
                debouncedReportError(e)
                throw e
            }
        }

        return {
            trans,
            ...ownProps,
            ...props,
            ...dispatchers,
        }



    }, ...args);
}

const connect = connectInner;
export { connect, batch };
/*

export function connect(mapStateToProps = null, mapDispatchToProps = null, mergeProps = null, options, ...args) {
    return (TheComponent) => {
        class ConnectWrapperComponent extends Component {
            component = null;

            static contextTypes = {
                freeze: PropTypes.bool,
                showFreeze: PropTypes.bool
            };

            constructor(props, context) {
                super(props, context);

                const areStatesEqual = (a, b) => {
                    if(this.context.freeze) {
                        console.log('frozen areStatesEqual');
                        return true;
                    }

                    if(options && options.areStatesEqual) {
                        return options.areStatesEqual(a, b);
                    }

                    return a === b;
                };

                this.component = connectInner(
                    mapStateToProps,
                    mapDispatchToProps,
                    mergeProps,
                    { areStatesEqual, ...options },
                    ...args
                )(TheComponent);
            };

            render() {
                let ConnectedComponent = this.component;

                return <ConnectedComponent {...this.props} />
            }
        }

        return ConnectWrapperComponent;
    }
}
*/
